import {useEffect, useState} from "react";
import {
    Container,
    Row,
    Col
} from "reactstrap";

import {RiBook2Line} from "react-icons/ri";

import Api from "../../components/helpers/Api";
import {SeoHelper} from "../../components/helpers/SeoHelper";
import {Link} from "react-router-dom";

export default function ScriptureSongsIndex() {

    const [passages, setPassages] = useState([]);
    const [books, setBooks] = useState([]);

    useEffect(() => {

        Api.get("/api/scripture-songs")
            .then(res => setPassages(res.data || []))
            .catch(err => {
                console.error("Failed to load passages", err);
            });

        Api.get("/api/testament/books")
            .then(res => setBooks(res.data || []))
            .catch(err => {
                console.error("Failed to load bible books", err);
            });

    }, []);

    useEffect(() => {

        if (typeof window.gtag === 'function') {
            window.gtag('event', 'view_scripture', {
                scripture_reference: 'index',
                source: 'browse'
            });
        }

    }, []);

    function formatBookName(value) {

        if (!value) return "";

        return value
            .replace(/-/g, " ")
            .split(" ")
            .map(p => p.charAt(0).toUpperCase() + p.slice(1))
            .join(" ");
    }

    sessionStorage.removeItem("selected-passages")

    return (
        <>
            <SeoHelper
                uri="/songs"
                title="Worship Songs for Bible Passages"
                description="Discover worship songs connected with Bible passages. Find songs for Psalms, Gospels, and other scriptures to help plan meaningful church services."
            />

            <section className="section section-lg">

                <Container>

                    <Row className="justify-content-center">

                        <Col lg="8">

                            <h1 className="display-3 text-center text-primary">
                                Worship Songs for Bible Passages
                            </h1>

                            <p className="lead text-center text-muted mb-5">
                                Explore worship songs connected with specific Bible passages
                                to help plan meaningful church services rooted in scripture.
                            </p>

                            <h2 className="h4 text-center mb-4">
                                Browse Songs by Bible Book
                            </h2>

                            <ul className="twb-next-steps">

                                {books.map(book => (

                                    <li key={book.slug}>
                                        <Link
                                            to={`/songs/${book.slug}`}
                                            className="twb-next-step"
                                        >

                                            <div className="twb-next-step-icon">
                                                <RiBook2Line size={24}/>
                                            </div>

                                            <div className="twb-next-step-text">
                                                Songs for {book.title || formatBookName(book.slug)}
                                            </div>

                                        </Link>
                                    </li>

                                ))}

                            </ul>

                            <p className="text-muted mt-5">
                                Many churches plan worship services around scripture readings.
                                These pages help you discover worship songs connected to specific
                                Bible passages such as Psalm 23, John 3:16, or Romans 8.
                            </p>

                            <p className="text-center text-muted mt-4">
                                Select a scripture passage to discover songs that connect with the message of that
                                reading.
                            </p>

                        </Col>

                    </Row>

                </Container>

            </section>
        </>
    );
}
